import React, { useEffect } from "react";
import WidgetGrid from "../WidgetGrid";
import * as Constants from "../logic/Constants";

// Externals
import cn from "classnames";

// DevExteme Components
import { Button } from "devextreme-react";

// Component styles
import classes from "./EmbeddedFormWidget.module.scss";

export function EmbeddedFormWidget(props) {
  const { ui, data, config, doAction, createChildWidget } = props;

  let grid = config ? config.ContentGrid : null;
  let showBorder = config ? config.ShowBorder : null;
  let collapsable = config ? config.Collapsable : null;
  let collapsed = config ? config.Collapsed : null;
  let collapsingAllowed = config ? config.CollapsingAllowed : null;
  let hasTitle = config ? config.HasTitle : null;
  let title = config ? config.Title : null;
  let showTopBar = hasTitle || collapsable;

  useEffect(() => {
    //console.log("EmbeddedFormWidget data of " + ui.id + ": ", data);
  }, [data]);

  const topBarHeight = () => {
    return config.TopBarHeight + "em";
  };

  const collapsableHeight = () => {
    if (collapsed) return 0;
    if (showTopBar) return "calc(100% - " + topBarHeight() + ")";
    return "100%";
  };

  const renderTopBar = () => {
    return (
      <div className={classes.topBar} style={{ height: topBarHeight() }}>
        <p className={classes.title}>{title}</p>
        <Button
          className={classes.collapseButton}
          icon={collapsed ? "chevrondown" : "chevronup"}
          stylingMode="text"
          onClick={() => doAction(collapsed ? Constants.EMBEDDEDFORM_WIDGET_EXPAND_ACTION : Constants.EMBEDDEDFORM_WIDGET_COLLAPSE_ACTION)}
          visible={collapsable}
          disabled={collapsingAllowed === false}
        />
      </div>
    );
  };

  return (
    <div className={cn(classes.container, showBorder ? classes.containerBorder : "", "dx-theme-border-color")}>
      {showTopBar ? renderTopBar() : null}
      <div className={classes.collapsableContainer} style={{ height: collapsableHeight() }} >
        {grid
          ? <WidgetGrid rows={grid.Rows} columns={grid.Columns} widgetLocations={grid.WidgetLocations} containingWidgets={ui.containingWidgets} createChildWidget={createChildWidget} />
          : null
        }
      </div>
    </div>
  );
}
